

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CancelAppointmentPublic
// ====================================================

export interface CancelAppointmentPublic {
  cancelAppointmentPublic: boolean;  // - Appointments can't be canceled if "until" is before the current date. - This mutation is not authenticated (it relies on the encrypted appointment data provided by email) - The appointment's user will be assumed as the user making the request - If there is no appointment, an error will be returned.
}

export interface CancelAppointmentPublicVariables {
  encryptedAppointment: string;
  message?: string | null;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CancelAppointment
// ====================================================

export interface CancelAppointment {
  cancelAppointment: boolean;  // - Appointments can't be canceled if "until" is before the current date. - Only admins, the same user who requested the appointment or super users can execute this mutation - If there is no appointment or if it is not taken by the current user, an error will be returned.
}

export interface CancelAppointmentVariables {
  appointment: AppointmentInput;
  message?: string | null;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ConfirmAppointment
// ====================================================

export interface ConfirmAppointment {
  confirmAppointment: boolean;  // - If the appointment is already canceled, the error 'User.CantConfirmCancelledAppointment' will be returned - Appointments can't be confirmed if "until" is before the current date. - Only resource admins and super users can confirm an appointment - If there is no appointment or if it is not taken by the provided user or the appointment is not `PENDING` (or `CONFIRMED` to be idempotent), an error will be returned. This mutation IS idempotent
}

export interface ConfirmAppointmentVariables {
  appointment: AppointmentInput;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateBusinessExportAppointments
// ====================================================

export interface CreateBusinessExportAppointments {
  export: boolean;  // Starts a new Appointments CSV export. User.ExportTooLong: Will fail if more than 6 months are requested. - Only admins and super users can execute this mutation
}

export interface CreateBusinessExportAppointmentsVariables {
  exportInput: ExportInput;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateException
// ====================================================

export interface CreateException {
  createException: boolean;  // Exceptions are not transactional, the resource should cancel possible pending appointments for that interval. - Only admins and super users can execute this mutation - This mutation is idempotent Returns true if the exception was created or was already created. Error if the user is not an admin of the business.
}

export interface CreateExceptionVariables {
  createExceptionInput: ExceptionInput;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteUser
// ====================================================

export interface DeleteUser {
  deleteUser: boolean;  // Will be removed: - email (remove field) - phoneNumber (remove field & global lock) - pictureUrl - admin role on businesses - push tokens - ALL firebase auth users linked with the configured phoneNumber Will CHANGE but won't be removed - FUTURE appointments will be canceled - user name ("Usuario Borrado") - notifications: all set to FALSE WON'T be removed: - userId - notifications & notifications-channels (has TTL) - appointments assigned to this user (will be canceled) - businesses created by the user (nor the appointments created BY the user)
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EnableResource
// ====================================================

export interface EnableResource_enableResource {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
}

export interface EnableResource {
  enableResource: EnableResource_enableResource;  // Disabled resources won't get new appointments, but pending and confirmed appointments will not be modified. - Only admins and super users can execute this mutation
}

export interface EnableResourceVariables {
  businessId: string;
  enabled: boolean;
  resourceId: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EnableService
// ====================================================

export interface EnableService_enableService {
  __typename: "Service";
  serviceId: string;
  enabled: boolean;
}

export interface EnableService {
  enableService: EnableService_enableService;  // Disabled service won't get new appointments, but pending and confirmed appointments will not be modified. - Only admins and super users can execute this mutation
}

export interface EnableServiceVariables {
  businessId: string;
  enabled: boolean;
  serviceId: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: GenericMakeAppointment
// ====================================================

export interface GenericMakeAppointment_genericMakeAppointment_payment {
  __typename: "Payment";
  link: AWSURL;                         // This link allows the user to pay for the appointment
  linkExpiration: AWSTimestamp;
  paymentId: string;
  mercadoPagoPaymentId: string | null;  // null if not payed
  externalReference: string;
  paidAt: AWSTimestamp | null;          // null if not payed
  price: number;
}

export interface GenericMakeAppointment_genericMakeAppointment {
  __typename: "Appointment";
  status: AppointmentStatus;
  payment: GenericMakeAppointment_genericMakeAppointment_payment | null;  // If present, the appointment requires a payment to be confirmed
}

export interface GenericMakeAppointment {
  genericMakeAppointment: GenericMakeAppointment_genericMakeAppointment;  // Inputs: - appointment: -- since: --- Only root or admins can disable availability and anticipation validations --- Appointments can't be requested if "since" is in the past (unless anticipation validation is disabled. In that case, since won't be validated, can even be on the past!). --- If the availability validation is disabled, service's and resource's weekly availability, exceptions, concurrency and overlapping will be ignored. --- Public and regular users: resource's and service's availability must include whole appointment (since + service duration) --- NOTE: Anticipation validations has a 5 min tolerance (eg: if the service min anticipation is 0, the appointment can be requested up to 5 min after it started) - requiredPayment (optional): -- Admins can omit this parameter on any type of service (payment won't be required and the appointment will be confirmed immediately, regardless if the service requiresConfirmation or not). -- Admins can provide an arbitrary amount to generate a payment link even if the service is not configured to receive payments (the appointment won't be confirmed until the payment succeeds). -- Public and regular users: this must only be provided if the service has a configured requiredPayment amount (the amount must be equal to the amount on the service). -- This mutation will fail if the business doesn't have a linked MP user and requiredPayment is provided Other rules: - The resource must be one of the service resources. If not, an error will be returned. - A single user can take the same spot multiple times (if the concurrency allows it). There is no backend limitation nor validation for this. - This mutation is idempotent: if all of the following remain equal, the mutation can be executed multiple times without generating new appointments -- businessId, resourceId, userId (or phoneNumber), since, createdAt TODO currently it's NOT idempotent NOTE: try to minimize the usage of the following response fields to avoid higher latencies and additional charges on dynamo: - business, resource, service
}

export interface GenericMakeAppointmentVariables {
  appointment: GenericAppointmentInput;
  requiredPayment?: RequiredPaymentInput | null;
  makeAppointmentValidationsInput: MakeAppointmentValidationsInput;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: InviteAdmin
// ====================================================

export interface InviteAdmin {
  inviteAdmin: boolean;  // Max admin count is 20. Creates a new user if there are no user with the provided phoneNumber (if not, the name of the current user won't be changed). An SMS will be sent if the user didn't exist, a push notification otherwise. - Only admins and super users can execute this mutation
}

export interface InviteAdminVariables {
  businessId: string;
  userName?: string | null;
  userPhoneNumber: AWSPhone;
  readOnly?: boolean | null;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LinkMercadoPagoAccountURL
// ====================================================

export interface LinkMercadoPagoAccountURL {
  linkMercadoPagoAccountURL: string;  // Returns a URL to start the Mercado Pago login flow. On completion, the user will be redirected to a public Appointia "web site". The login flow will expire in 24 hours (will be able to start it but not to register the tokens). - Only admins and super users can execute this mutation
}

export interface LinkMercadoPagoAccountURLVariables {
  businessId: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveAdmin
// ====================================================

export interface RemoveAdmin {
  removeAdmin: boolean;  // - Returns true if the business exists and the userId is no longer part of the business' admins. - Only admins and super users can execute this mutation
}

export interface RemoveAdminVariables {
  businessId: string;
  userId: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveException
// ====================================================

export interface RemoveException {
  deleteException: boolean;  // Returns null if the exception didn´t exist. - Only admins and super users can execute this mutation - This mutation is idempotent Returns true if the exception was deleted or doesn't exist. Error if the user is not an admin of the business.
}

export interface RemoveExceptionVariables {
  businessId: string;
  resourceId: string;
  since: AWSTimestamp;
  until: AWSTimestamp;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RequestHelp
// ====================================================

export interface RequestHelp {
  requestHelp: boolean;  // Returns true if a support ticket was created
}

export interface RequestHelpVariables {
  input: RequestHelpInput;
  metadata: AWSJSON;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RequestRegisterBusiness
// ====================================================

export interface RequestRegisterBusiness {
  requestBusinessRegistration: boolean;  // Returns true if a support ticket was created
}

export interface RequestRegisterBusinessVariables {
  input: RequestBusinessRegistrationInput;
  metadata: AWSJSON;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendSMSValidationCode
// ====================================================

export interface SendSMSValidationCode {
  sendSMSValidationCode: boolean;  // Sends an sms validation code to the provided phone number (E.164 format) - Execute this mutation again to resend the validation code - The same code will be returned until the user tries to validate it (setPhoneNumber) at least 5 times, then a new code will be sent - The user can only request a limited number of SMS. If exceeded, a 'User.TooManySMSValidationCodesRequested' error will be returned - Only users with verified email can execute this mutation.
}

export interface SendSMSValidationCodeVariables {
  phoneNumber: AWSPhone;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetBusiness
// ====================================================

export interface SetBusiness {
  setBusiness: boolean;  // If the business doesn't exist, the current user will be set as admin. If the business already exists and the current user is not an admin nor super user, an error will be returned. If the provided handle is already owned by another business a 'User.HandleNotAvailable' error will be returned. WARNING: Business handle CAN'T be changed using set business, use updateBusinessHandle mutation for that. WARNING: it ALWAYS adds the current user as admin (even super users) - Only users with verified email can execute this mutation. - Only super users can create new businesses, admins can only update a business. - Only admins and super users with verified email can execute this mutation.
}

export interface SetBusinessVariables {
  input: BusinessInput;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetDeviceToken
// ====================================================

export interface SetDeviceToken {
  setDeviceToken: boolean;  // Overrides or associates the current user with this device token
}

export interface SetDeviceTokenVariables {
  deviceToken: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetPhoneNumber
// ====================================================

export interface SetPhoneNumber {
  setPhoneNumber: boolean;  // Sets the current phone number of the user (E.164 format). Fails if code is invalid or expired. This mutation may change custom claims for the jwt. The client should trigger a refresh token to get the latest values. - Only users with verified email can execute this mutation. User.ExpiredValidationCode: If no code was present User.TooManyValidationAttempts: If there are no more attempts left => send a new code with sendSMSValidationCode User.InvalidValidationCode: The code was different than the one on the SMS
}

export interface SetPhoneNumberVariables {
  phoneNumber: AWSPhone;
  validationCode: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetResource
// ====================================================

export interface SetResource_setResource_overlappingRequirements {
  __typename: "OverlappingRequirements";
  sameInterval: boolean;  // All overlappoing appointments must have the same "since" and "until" interval
  sameService: boolean;   // All overlappoing appointments must be from the same service
}

export interface SetResource_setResource_weeklyAvailability {
  __typename: "AvailabilitySpot";
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  weekday: Weekday | null;
}

export interface SetResource_setResource {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  description: string | null;
  enabled: boolean;
  name: string;
  pictureUrl: AWSURL | null;
  labels: string[];
  resourceType: ResourceType;
  overlappingRequirements: SetResource_setResource_overlappingRequirements;
  weeklyAvailability: SetResource_setResource_weeklyAvailability[];
}

export interface SetResource {
  setResource: SetResource_setResource;  // If already exists and the current user is not an admin of the business nor super user, an error will be returned. - Only admins or super users with verified email can execute this mutation.
}

export interface SetResourceVariables {
  input: ResourceInput;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetService
// ====================================================

export interface SetService_setService_weeklyAvailability {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
}

export interface SetService_setService_weeklyAvailabilityByIntervals {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
}

export interface SetService_setService {
  __typename: "Service";
  enabled: boolean;
  serviceId: string;
  name: string;
  description: string | null;
  price: number | null;
  requiresConfirmation: boolean;
  durationMinutes: number;                                                               // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  resourcesId: string[];
  minAnticipationHours: number;
  maxAnticipationDays: number;
  concurrency: number;
  appointmentsFrequencyMinutes: number;
  requiredPayment: number;                                                               // Amount to charge the user to confirm the appointment. Zero if a payment is not required to confirm the appointments (can't be combined with 'requiresConfirmation')
  weeklyAvailability: SetService_setService_weeklyAvailability[];
  weeklyAvailabilityByIntervals: SetService_setService_weeklyAvailabilityByIntervals[];  // Only to store and retrieve the same data the user provided, duplicates info from weeklyAvailability (not used internally)
}

export interface SetService {
  setService: SetService_setService;  // If already exists and the current user is not an admin of the business nor super user, an error will be returned. - Only admins or super users with verified email can execute this mutation.
}

export interface SetServiceVariables {
  input: ServiceInput;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UnlinkMercadoPagoAccount
// ====================================================

export interface UnlinkMercadoPagoAccount {
  unlinkMercadoPagoAccount: boolean;  // After this mutation, no new appointments on services with payments are allowed. MP credentials are kept for longer to process any pending payment notifications from MP. - Only admins and super users can execute this mutation
}

export interface UnlinkMercadoPagoAccountVariables {
  businessId: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateBusinessHandle
// ====================================================

export interface UpdateBusinessHandle {
  updateBusinessHandle: boolean;  // Removed the previous businessHandle and sets the new one. Fails if the current handle is not owned by the business. If the new handle is already owned by another business a 'User.HandleNotAvailable' error will be returned. - newHandle must be URL safe (must remain unchanged if encoded using application/x-www-form-urlencoded) - Only admins and super users with verified email can execute this mutation.
}

export interface UpdateBusinessHandleVariables {
  businessId: string;
  currentHandle: string;
  newHandle: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateBusinessNotifications
// ====================================================

export interface UpdateBusinessNotifications {
  updateBusinessNotifications: AWSJSON;  // Update notifications for this user as an admin of a single business Fails if the user is not an admin of the business.
}

export interface UpdateBusinessNotificationsVariables {
  businessId: string;
  config: NotificationsInput;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateName
// ====================================================

export interface UpdateName_updateName_businessesV2_business_resources {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  name: string;
  pictureUrl: AWSURL | null;
  enabled: boolean;
}

export interface UpdateName_updateName_businessesV2_business {
  __typename: "Business";
  businessId: string;
  name: string;
  pictureUrl: AWSURL | null;
  timezone: string;
  businessHandle: string;
  email: AWSEmail | null;
  enabled: boolean;
  mercadoPagoLinked: boolean;  // This query can be used by any user (kept public to allow checking it before displaying the services) Returns true if the connection with a Mercado Pago account was set and can be used to require payments on services
  resources: UpdateName_updateName_businessesV2_business_resources[];
}

export interface UpdateName_updateName_businessesV2 {
  __typename: "UserBusiness";
  business: UpdateName_updateName_businessesV2_business;
  readOnly: boolean;  // false if the user as an admin can make updates to the appointments or configuration of the business
}

export interface UpdateName_updateName_favoriteBusinesses {
  __typename: "Business";
  businessId: string;
  businessHandle: string;
  name: string;
  pictureUrl: AWSURL | null;
  isDemo: boolean;
  enabled: boolean;
}

export interface UpdateName_updateName {
  __typename: "User";
  userId: string;
  email: AWSEmail | null;                                          // User email is optional because businesses can create users with only the phone number
  name: string | null;
  phoneNumber: AWSPhone | null;                                    // User phoneNumber is optional because the user could "take" the phoneNumber of another user (removing it's phone number)
  pictureUrl: AWSURL | null;
  businessesV2: UpdateName_updateName_businessesV2[];              // Businesses where the users is an admin or a read-only admin - Only roots or the logged in user can ask for user's businesses
  favoriteBusinesses: UpdateName_updateName_favoriteBusinesses[];  // From the latest 10 appointments, gets at most 6 distinct Businesses
}

export interface UpdateName {
  updateName: UpdateName_updateName;  // Fail if the user has no email & phoneNumber validated (customUserId)
}

export interface UpdateNameVariables {
  name: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateUserNotifications
// ====================================================

export interface UpdateUserNotifications_updateNotifications {
  __typename: "Notifications";
  email: boolean;
  push: boolean;
  sms: boolean;
}

export interface UpdateUserNotifications {
  updateNotifications: UpdateUserNotifications_updateNotifications;
}

export interface UpdateUserNotificationsVariables {
  config: NotificationsInput;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAppointment
// ====================================================

export interface GetAppointment_appointment_business_weeklyAvailability {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
}

export interface GetAppointment_appointment_business__geoloc {
  __typename: "GeoLoc";
  lng: number;
  lat: number;
}

export interface GetAppointment_appointment_business_address {
  __typename: "Address";
  country: string;
  city: string;
  street: string;
  number: string;
  zipcode: string;
  directions: string | null;  // Floor, department, etc.
}

export interface GetAppointment_appointment_business {
  __typename: "Business";
  businessId: string;
  businessHandle: string;
  name: string;
  description: string | null;
  category: string;
  phoneNumber: AWSPhone;
  timezone: string;
  enabled: boolean;
  cancellationPolicy: string | null;
  weeklyAvailability: GetAppointment_appointment_business_weeklyAvailability[];
  paymentMethods: PaymentMethod[];
  website: AWSURL | null;
  email: AWSEmail | null;
  instagramProfileUrl: AWSURL | null;
  facebookProfileUrl: AWSURL | null;
  twitterProfileUrl: AWSURL | null;
  pictureUrl: AWSURL | null;
  backgroundPictureUrl: AWSURL | null;
  isDemo: boolean;
  _geoloc: GetAppointment_appointment_business__geoloc;
  address: GetAppointment_appointment_business_address;
  mercadoPagoLinked: boolean;  // This query can be used by any user (kept public to allow checking it before displaying the services) Returns true if the connection with a Mercado Pago account was set and can be used to require payments on services
}

export interface GetAppointment_appointment_service_weeklyAvailability {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
}

export interface GetAppointment_appointment_service_weeklyAvailabilityByIntervals {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
}

export interface GetAppointment_appointment_service {
  __typename: "Service";
  enabled: boolean;
  serviceId: string;
  name: string;
  description: string | null;
  price: number | null;
  requiresConfirmation: boolean;
  durationMinutes: number;                                                                            // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  resourcesId: string[];
  minAnticipationHours: number;
  maxAnticipationDays: number;
  concurrency: number;
  appointmentsFrequencyMinutes: number;
  requiredPayment: number;                                                                            // Amount to charge the user to confirm the appointment. Zero if a payment is not required to confirm the appointments (can't be combined with 'requiresConfirmation')
  weeklyAvailability: GetAppointment_appointment_service_weeklyAvailability[];
  weeklyAvailabilityByIntervals: GetAppointment_appointment_service_weeklyAvailabilityByIntervals[];  // Only to store and retrieve the same data the user provided, duplicates info from weeklyAvailability (not used internally)
}

export interface GetAppointment_appointment_resource_overlappingRequirements {
  __typename: "OverlappingRequirements";
  sameInterval: boolean;  // All overlappoing appointments must have the same "since" and "until" interval
  sameService: boolean;   // All overlappoing appointments must be from the same service
}

export interface GetAppointment_appointment_resource_weeklyAvailability {
  __typename: "AvailabilitySpot";
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  weekday: Weekday | null;
}

export interface GetAppointment_appointment_resource {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  description: string | null;
  enabled: boolean;
  name: string;
  pictureUrl: AWSURL | null;
  labels: string[];
  resourceType: ResourceType;
  overlappingRequirements: GetAppointment_appointment_resource_overlappingRequirements;
  weeklyAvailability: GetAppointment_appointment_resource_weeklyAvailability[];
}

export interface GetAppointment_appointment_payment {
  __typename: "Payment";
  link: AWSURL;                         // This link allows the user to pay for the appointment
  linkExpiration: AWSTimestamp;
  paymentId: string;
  mercadoPagoPaymentId: string | null;  // null if not payed
  externalReference: string;
  paidAt: AWSTimestamp | null;          // null if not payed
  price: number;
}

export interface GetAppointment_appointment {
  __typename: "Appointment";
  status: AppointmentStatus;
  description: string | null;
  since: AWSTimestamp;
  until: AWSTimestamp;
  createdAt: AWSTimestamp;
  cancellationMessage: string | null;
  statusCause: AppointmentStatusCause;                 // Explain the cause (user, admin or payment) of why is in the current status
  business: GetAppointment_appointment_business;
  service: GetAppointment_appointment_service;
  resource: GetAppointment_appointment_resource;
  price: number | null;
  payment: GetAppointment_appointment_payment | null;  // If present, the appointment requires a payment to be confirmed
}

export interface GetAppointment {
  appointment: GetAppointment_appointment | null;  // Can only get appointments for the current user. Returns null if doesn't exist. - Only users with verified email can execute this query.
}

export interface GetAppointmentVariables {
  userAppointmentInput: UserAppointmentInput;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAppointments
// ====================================================

export interface GetAppointments_appointments_items_business_weeklyAvailability {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
}

export interface GetAppointments_appointments_items_business__geoloc {
  __typename: "GeoLoc";
  lng: number;
  lat: number;
}

export interface GetAppointments_appointments_items_business_address {
  __typename: "Address";
  country: string;
  city: string;
  street: string;
  number: string;
  zipcode: string;
  directions: string | null;  // Floor, department, etc.
}

export interface GetAppointments_appointments_items_business {
  __typename: "Business";
  businessId: string;
  businessHandle: string;
  name: string;
  description: string | null;
  category: string;
  phoneNumber: AWSPhone;
  timezone: string;
  enabled: boolean;
  cancellationPolicy: string | null;
  weeklyAvailability: GetAppointments_appointments_items_business_weeklyAvailability[];
  paymentMethods: PaymentMethod[];
  website: AWSURL | null;
  email: AWSEmail | null;
  instagramProfileUrl: AWSURL | null;
  facebookProfileUrl: AWSURL | null;
  twitterProfileUrl: AWSURL | null;
  pictureUrl: AWSURL | null;
  backgroundPictureUrl: AWSURL | null;
  isDemo: boolean;
  _geoloc: GetAppointments_appointments_items_business__geoloc;
  address: GetAppointments_appointments_items_business_address;
  mercadoPagoLinked: boolean;  // This query can be used by any user (kept public to allow checking it before displaying the services) Returns true if the connection with a Mercado Pago account was set and can be used to require payments on services
}

export interface GetAppointments_appointments_items_service_weeklyAvailability {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
}

export interface GetAppointments_appointments_items_service_weeklyAvailabilityByIntervals {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
}

export interface GetAppointments_appointments_items_service {
  __typename: "Service";
  enabled: boolean;
  serviceId: string;
  name: string;
  description: string | null;
  price: number | null;
  requiresConfirmation: boolean;
  durationMinutes: number;                                                                                    // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  resourcesId: string[];
  minAnticipationHours: number;
  maxAnticipationDays: number;
  concurrency: number;
  appointmentsFrequencyMinutes: number;
  requiredPayment: number;                                                                                    // Amount to charge the user to confirm the appointment. Zero if a payment is not required to confirm the appointments (can't be combined with 'requiresConfirmation')
  weeklyAvailability: GetAppointments_appointments_items_service_weeklyAvailability[];
  weeklyAvailabilityByIntervals: GetAppointments_appointments_items_service_weeklyAvailabilityByIntervals[];  // Only to store and retrieve the same data the user provided, duplicates info from weeklyAvailability (not used internally)
}

export interface GetAppointments_appointments_items_resource_overlappingRequirements {
  __typename: "OverlappingRequirements";
  sameInterval: boolean;  // All overlappoing appointments must have the same "since" and "until" interval
  sameService: boolean;   // All overlappoing appointments must be from the same service
}

export interface GetAppointments_appointments_items_resource_weeklyAvailability {
  __typename: "AvailabilitySpot";
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  weekday: Weekday | null;
}

export interface GetAppointments_appointments_items_resource {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  description: string | null;
  enabled: boolean;
  name: string;
  pictureUrl: AWSURL | null;
  labels: string[];
  resourceType: ResourceType;
  overlappingRequirements: GetAppointments_appointments_items_resource_overlappingRequirements;
  weeklyAvailability: GetAppointments_appointments_items_resource_weeklyAvailability[];
}

export interface GetAppointments_appointments_items_payment {
  __typename: "Payment";
  link: AWSURL;                         // This link allows the user to pay for the appointment
  linkExpiration: AWSTimestamp;
  paymentId: string;
  mercadoPagoPaymentId: string | null;  // null if not payed
  externalReference: string;
  paidAt: AWSTimestamp | null;          // null if not payed
  price: number;
}

export interface GetAppointments_appointments_items {
  __typename: "Appointment";
  status: AppointmentStatus;
  description: string | null;
  since: AWSTimestamp;
  until: AWSTimestamp;
  createdAt: AWSTimestamp;
  cancellationMessage: string | null;
  statusCause: AppointmentStatusCause;                         // Explain the cause (user, admin or payment) of why is in the current status
  business: GetAppointments_appointments_items_business;
  service: GetAppointments_appointments_items_service;
  resource: GetAppointments_appointments_items_resource;
  price: number | null;
  payment: GetAppointments_appointments_items_payment | null;  // If present, the appointment requires a payment to be confirmed
}

export interface GetAppointments_appointments {
  __typename: "AppointmentsConnection";
  items: GetAppointments_appointments_items[];
  nextToken: string | null;
}

export interface GetAppointments {
  appointments: GetAppointments_appointments;  // Default values: limit = 10, ascending = true Current user appointments between since (inclusive) and until (exclusive).
}

export interface GetAppointmentsVariables {
  since: AWSTimestamp;
  until: AWSTimestamp;
  nextToken?: string | null;
  limit?: number | null;
  ascending?: boolean | null;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBusiness
// ====================================================

export interface GetBusiness_business_weeklyAvailability {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
}

export interface GetBusiness_business__geoloc {
  __typename: "GeoLoc";
  lng: number;
  lat: number;
}

export interface GetBusiness_business_address {
  __typename: "Address";
  country: string;
  city: string;
  street: string;
  number: string;
  zipcode: string;
  directions: string | null;  // Floor, department, etc.
}

export interface GetBusiness_business_resources_overlappingRequirements {
  __typename: "OverlappingRequirements";
  sameInterval: boolean;  // All overlappoing appointments must have the same "since" and "until" interval
  sameService: boolean;   // All overlappoing appointments must be from the same service
}

export interface GetBusiness_business_resources_weeklyAvailability {
  __typename: "AvailabilitySpot";
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  weekday: Weekday | null;
}

export interface GetBusiness_business_resources {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  description: string | null;
  enabled: boolean;
  name: string;
  pictureUrl: AWSURL | null;
  labels: string[];
  resourceType: ResourceType;
  overlappingRequirements: GetBusiness_business_resources_overlappingRequirements;
  weeklyAvailability: GetBusiness_business_resources_weeklyAvailability[];
}

export interface GetBusiness_business_services_weeklyAvailability {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
}

export interface GetBusiness_business_services_weeklyAvailabilityByIntervals {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
}

export interface GetBusiness_business_services {
  __typename: "Service";
  enabled: boolean;
  serviceId: string;
  name: string;
  description: string | null;
  price: number | null;
  requiresConfirmation: boolean;
  durationMinutes: number;                                                                       // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  resourcesId: string[];
  minAnticipationHours: number;
  maxAnticipationDays: number;
  concurrency: number;
  appointmentsFrequencyMinutes: number;
  requiredPayment: number;                                                                       // Amount to charge the user to confirm the appointment. Zero if a payment is not required to confirm the appointments (can't be combined with 'requiresConfirmation')
  weeklyAvailability: GetBusiness_business_services_weeklyAvailability[];
  weeklyAvailabilityByIntervals: GetBusiness_business_services_weeklyAvailabilityByIntervals[];  // Only to store and retrieve the same data the user provided, duplicates info from weeklyAvailability (not used internally)
}

export interface GetBusiness_business_mercadoPagoLinkedUser {
  __typename: "MercadoPagoUser";
  firstName: string | null;
  lastName: string | null;
  nickname: string | null;
  profilePicture: AWSURL | null;
  mercadoPagoUserId: string;
  countryCode: string | null;
  createdAt: AWSTimestamp;
  updatedAt: AWSTimestamp;
}

export interface GetBusiness_business_admins {
  __typename: "User";
  userId: string;
  name: string | null;
  phoneNumber: AWSPhone | null;  // User phoneNumber is optional because the user could "take" the phoneNumber of another user (removing it's phone number)
  pictureUrl: AWSURL | null;
}

export interface GetBusiness_business_readOnlyAdmins {
  __typename: "User";
  userId: string;
  name: string | null;
  phoneNumber: AWSPhone | null;  // User phoneNumber is optional because the user could "take" the phoneNumber of another user (removing it's phone number)
  pictureUrl: AWSURL | null;
}

export interface GetBusiness_business {
  __typename: "Business";
  businessId: string;
  businessHandle: string;
  name: string;
  description: string | null;
  category: string;
  phoneNumber: AWSPhone;
  timezone: string;
  enabled: boolean;
  cancellationPolicy: string | null;
  weeklyAvailability: GetBusiness_business_weeklyAvailability[];
  paymentMethods: PaymentMethod[];
  website: AWSURL | null;
  email: AWSEmail | null;
  instagramProfileUrl: AWSURL | null;
  facebookProfileUrl: AWSURL | null;
  twitterProfileUrl: AWSURL | null;
  pictureUrl: AWSURL | null;
  backgroundPictureUrl: AWSURL | null;
  isDemo: boolean;
  _geoloc: GetBusiness_business__geoloc;
  address: GetBusiness_business_address;
  mercadoPagoLinked: boolean;                                                // This query can be used by any user (kept public to allow checking it before displaying the services) Returns true if the connection with a Mercado Pago account was set and can be used to require payments on services
  resources: GetBusiness_business_resources[];
  services: GetBusiness_business_services[];
  mercadoPagoLinkedUser: GetBusiness_business_mercadoPagoLinkedUser | null;  // Get the Mercado Pago user account that was linked or null if no user account was linked. - Only admins and super users can execute this query
  admins: GetBusiness_business_admins[];                                     // - Only admins and super users can execute this query
  readOnlyAdmins: GetBusiness_business_readOnlyAdmins[];                     // - Only admins and super users can execute this query
}

export interface GetBusiness {
  business: GetBusiness_business | null;  // Returns null if not found
}

export interface GetBusinessVariables {
  businessId: string;
  fetchMPLinkedUser?: boolean | null;
  fetchAdmins?: boolean | null;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBusinessAdmins
// ====================================================

export interface GetBusinessAdmins_business_admins {
  __typename: "User";
  userId: string;
  name: string | null;
  phoneNumber: AWSPhone | null;  // User phoneNumber is optional because the user could "take" the phoneNumber of another user (removing it's phone number)
  pictureUrl: AWSURL | null;
}

export interface GetBusinessAdmins_business_readOnlyAdmins {
  __typename: "User";
  userId: string;
  name: string | null;
  phoneNumber: AWSPhone | null;  // User phoneNumber is optional because the user could "take" the phoneNumber of another user (removing it's phone number)
  pictureUrl: AWSURL | null;
}

export interface GetBusinessAdmins_business {
  __typename: "Business";
  admins: GetBusinessAdmins_business_admins[];                  // - Only admins and super users can execute this query
  readOnlyAdmins: GetBusinessAdmins_business_readOnlyAdmins[];  // - Only admins and super users can execute this query
}

export interface GetBusinessAdmins {
  business: GetBusinessAdmins_business | null;  // Returns null if not found
}

export interface GetBusinessAdminsVariables {
  businessId: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBusinessAppointment
// ====================================================

export interface GetBusinessAppointment_business_appointment_business_address {
  __typename: "Address";
  country: string;
  city: string;
  street: string;
  number: string;
  zipcode: string;
  directions: string | null;  // Floor, department, etc.
}

export interface GetBusinessAppointment_business_appointment_business {
  __typename: "Business";
  businessId: string;
  timezone: string;
  name: string;
  address: GetBusinessAppointment_business_appointment_business_address;
}

export interface GetBusinessAppointment_business_appointment_resource {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  name: string;
  pictureUrl: AWSURL | null;
}

export interface GetBusinessAppointment_business_appointment_service {
  __typename: "Service";
  serviceId: string;
  name: string;
  price: number | null;
  requiredPayment: number;  // Amount to charge the user to confirm the appointment. Zero if a payment is not required to confirm the appointments (can't be combined with 'requiresConfirmation')
}

export interface GetBusinessAppointment_business_appointment_user {
  __typename: "User";
  userId: string;
  email: AWSEmail | null;        // User email is optional because businesses can create users with only the phone number
  name: string | null;
  phoneNumber: AWSPhone | null;  // User phoneNumber is optional because the user could "take" the phoneNumber of another user (removing it's phone number)
  pictureUrl: AWSURL | null;
}

export interface GetBusinessAppointment_business_appointment_createdBy {
  __typename: "User";
  userId: string;
  name: string | null;
  pictureUrl: AWSURL | null;
}

export interface GetBusinessAppointment_business_appointment_payment {
  __typename: "Payment";
  link: AWSURL;                         // This link allows the user to pay for the appointment
  linkExpiration: AWSTimestamp;
  paymentId: string;
  mercadoPagoPaymentId: string | null;  // null if not payed
  externalReference: string;
  paidAt: AWSTimestamp | null;          // null if not payed
  price: number;
}

export interface GetBusinessAppointment_business_appointment {
  __typename: "BusinessAppointment";
  business: GetBusinessAppointment_business_appointment_business;
  createdAt: AWSTimestamp;
  description: string | null;
  durationMinutes: number;
  price: number | null;
  resource: GetBusinessAppointment_business_appointment_resource;
  service: GetBusinessAppointment_business_appointment_service;
  since: AWSTimestamp;
  status: AppointmentStatus;
  statusCause: AppointmentStatusCause;                                  // Explain the cause (user, admin or payment) of why is in the current status
  cancellationMessage: string | null;
  until: AWSTimestamp;
  user: GetBusinessAppointment_business_appointment_user;
  createdBy: GetBusinessAppointment_business_appointment_createdBy;
  payment: GetBusinessAppointment_business_appointment_payment | null;  // If present, the appointment requires a payment to be confirmed
}

export interface GetBusinessAppointment_business {
  __typename: "Business";
  appointment: GetBusinessAppointment_business_appointment | null;  // Get single business' appointment. Returns null if doesn't exist. - Only admins, read-only admins and super users can execute this query
}

export interface GetBusinessAppointment {
  business: GetBusinessAppointment_business | null;  // Returns null if not found
}

export interface GetBusinessAppointmentVariables {
  businessId: string;
  businessAppointmentInput: BusinessAppointmentInput;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBusinessAppointments
// ====================================================

export interface GetBusinessAppointments_business_appointments_items_business {
  __typename: "Business";
  businessId: string;
  timezone: string;
  name: string;
}

export interface GetBusinessAppointments_business_appointments_items_resource {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  name: string;
  pictureUrl: AWSURL | null;
}

export interface GetBusinessAppointments_business_appointments_items_service {
  __typename: "Service";
  serviceId: string;
  name: string;
  price: number | null;
}

export interface GetBusinessAppointments_business_appointments_items_user {
  __typename: "User";
  userId: string;
  email: AWSEmail | null;        // User email is optional because businesses can create users with only the phone number
  name: string | null;
  phoneNumber: AWSPhone | null;  // User phoneNumber is optional because the user could "take" the phoneNumber of another user (removing it's phone number)
  pictureUrl: AWSURL | null;
}

export interface GetBusinessAppointments_business_appointments_items_payment {
  __typename: "Payment";
  link: AWSURL;                         // This link allows the user to pay for the appointment
  linkExpiration: AWSTimestamp;
  paymentId: string;
  mercadoPagoPaymentId: string | null;  // null if not payed
  externalReference: string;
  paidAt: AWSTimestamp | null;          // null if not payed
  price: number;
}

export interface GetBusinessAppointments_business_appointments_items {
  __typename: "AdminAppointment";
  business: GetBusinessAppointments_business_appointments_items_business;
  createdAt: AWSTimestamp;
  description: string | null;
  durationMinutes: number;
  price: number | null;
  resource: GetBusinessAppointments_business_appointments_items_resource;
  service: GetBusinessAppointments_business_appointments_items_service;
  since: AWSTimestamp;
  status: AppointmentStatus;
  statusCause: AppointmentStatusCause;                                          // Explain the cause (user, admin or payment) of why is in the current status
  cancellationMessage: string | null;
  until: AWSTimestamp;
  user: GetBusinessAppointments_business_appointments_items_user;
  createdByUserId: string;
  payment: GetBusinessAppointments_business_appointments_items_payment | null;  // If present, the appointment requires a payment to be confirmed
}

export interface GetBusinessAppointments_business_appointments {
  __typename: "AdminAppointmentsConnection";
  nextToken: string | null;
  items: GetBusinessAppointments_business_appointments_items[];
}

export interface GetBusinessAppointments_business {
  __typename: "Business";
  appointments: GetBusinessAppointments_business_appointments;  // Returns appointments between since (inclusive) and until (exclusive). - Only admins, read-only admins and super users can execute this query
}

export interface GetBusinessAppointments {
  business: GetBusinessAppointments_business | null;  // Returns null if not found
}

export interface GetBusinessAppointmentsVariables {
  businessId: string;
  since: AWSTimestamp;
  until: AWSTimestamp;
  nextToken?: string | null;
  limit?: number | null;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBusinessAppointmentsForResource
// ====================================================

export interface GetBusinessAppointmentsForResource_resource_appointments_items_business {
  __typename: "Business";
  businessId: string;
  timezone: string;
  name: string;
}

export interface GetBusinessAppointmentsForResource_resource_appointments_items_resource {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  name: string;
  pictureUrl: AWSURL | null;
}

export interface GetBusinessAppointmentsForResource_resource_appointments_items_service {
  __typename: "Service";
  serviceId: string;
  name: string;
  price: number | null;
}

export interface GetBusinessAppointmentsForResource_resource_appointments_items_user {
  __typename: "User";
  userId: string;
  email: AWSEmail | null;        // User email is optional because businesses can create users with only the phone number
  name: string | null;
  phoneNumber: AWSPhone | null;  // User phoneNumber is optional because the user could "take" the phoneNumber of another user (removing it's phone number)
  pictureUrl: AWSURL | null;
}

export interface GetBusinessAppointmentsForResource_resource_appointments_items_payment {
  __typename: "Payment";
  link: AWSURL;                         // This link allows the user to pay for the appointment
  linkExpiration: AWSTimestamp;
  paymentId: string;
  mercadoPagoPaymentId: string | null;  // null if not payed
  externalReference: string;
  paidAt: AWSTimestamp | null;          // null if not payed
  price: number;
}

export interface GetBusinessAppointmentsForResource_resource_appointments_items {
  __typename: "AdminAppointment";
  business: GetBusinessAppointmentsForResource_resource_appointments_items_business;
  createdAt: AWSTimestamp;
  description: string | null;
  durationMinutes: number;
  price: number | null;
  resource: GetBusinessAppointmentsForResource_resource_appointments_items_resource;
  service: GetBusinessAppointmentsForResource_resource_appointments_items_service;
  since: AWSTimestamp;
  status: AppointmentStatus;
  statusCause: AppointmentStatusCause;                                                     // Explain the cause (user, admin or payment) of why is in the current status
  cancellationMessage: string | null;
  until: AWSTimestamp;
  user: GetBusinessAppointmentsForResource_resource_appointments_items_user;
  createdByUserId: string;
  payment: GetBusinessAppointmentsForResource_resource_appointments_items_payment | null;  // If present, the appointment requires a payment to be confirmed
}

export interface GetBusinessAppointmentsForResource_resource_appointments {
  __typename: "AdminAppointmentsConnection";
  nextToken: string | null;
  items: GetBusinessAppointmentsForResource_resource_appointments_items[];
}

export interface GetBusinessAppointmentsForResource_resource {
  __typename: "Resource";
  appointments: GetBusinessAppointmentsForResource_resource_appointments;  // Returns appointments between since (inclusive) and until (exclusive). - Only admins, read-only admins and super users can execute this query
}

export interface GetBusinessAppointmentsForResource {
  resource: GetBusinessAppointmentsForResource_resource | null;  // Returns null if not found
}

export interface GetBusinessAppointmentsForResourceVariables {
  businessId: string;
  resourceId: string;
  since: AWSTimestamp;
  until: AWSTimestamp;
  nextToken?: string | null;
  limit?: number | null;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBusinessByHandle
// ====================================================

export interface GetBusinessByHandle_businessByHandle_business_weeklyAvailability {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
}

export interface GetBusinessByHandle_businessByHandle_business__geoloc {
  __typename: "GeoLoc";
  lng: number;
  lat: number;
}

export interface GetBusinessByHandle_businessByHandle_business_address {
  __typename: "Address";
  country: string;
  city: string;
  street: string;
  number: string;
  zipcode: string;
  directions: string | null;  // Floor, department, etc.
}

export interface GetBusinessByHandle_businessByHandle_business_resources_overlappingRequirements {
  __typename: "OverlappingRequirements";
  sameInterval: boolean;  // All overlappoing appointments must have the same "since" and "until" interval
  sameService: boolean;   // All overlappoing appointments must be from the same service
}

export interface GetBusinessByHandle_businessByHandle_business_resources_weeklyAvailability {
  __typename: "AvailabilitySpot";
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  weekday: Weekday | null;
}

export interface GetBusinessByHandle_businessByHandle_business_resources {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  description: string | null;
  enabled: boolean;
  name: string;
  pictureUrl: AWSURL | null;
  labels: string[];
  resourceType: ResourceType;
  overlappingRequirements: GetBusinessByHandle_businessByHandle_business_resources_overlappingRequirements;
  weeklyAvailability: GetBusinessByHandle_businessByHandle_business_resources_weeklyAvailability[];
}

export interface GetBusinessByHandle_businessByHandle_business_services_weeklyAvailability {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
}

export interface GetBusinessByHandle_businessByHandle_business_services_weeklyAvailabilityByIntervals {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
}

export interface GetBusinessByHandle_businessByHandle_business_services {
  __typename: "Service";
  enabled: boolean;
  serviceId: string;
  name: string;
  description: string | null;
  price: number | null;
  requiresConfirmation: boolean;
  durationMinutes: number;                                                                                                // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  resourcesId: string[];
  minAnticipationHours: number;
  maxAnticipationDays: number;
  concurrency: number;
  appointmentsFrequencyMinutes: number;
  requiredPayment: number;                                                                                                // Amount to charge the user to confirm the appointment. Zero if a payment is not required to confirm the appointments (can't be combined with 'requiresConfirmation')
  weeklyAvailability: GetBusinessByHandle_businessByHandle_business_services_weeklyAvailability[];
  weeklyAvailabilityByIntervals: GetBusinessByHandle_businessByHandle_business_services_weeklyAvailabilityByIntervals[];  // Only to store and retrieve the same data the user provided, duplicates info from weeklyAvailability (not used internally)
}

export interface GetBusinessByHandle_businessByHandle_business_mercadoPagoLinkedUser {
  __typename: "MercadoPagoUser";
  firstName: string | null;
  lastName: string | null;
  nickname: string | null;
  profilePicture: AWSURL | null;
  mercadoPagoUserId: string;
  countryCode: string | null;
  createdAt: AWSTimestamp;
  updatedAt: AWSTimestamp;
}

export interface GetBusinessByHandle_businessByHandle_business_admins {
  __typename: "User";
  userId: string;
  name: string | null;
  phoneNumber: AWSPhone | null;  // User phoneNumber is optional because the user could "take" the phoneNumber of another user (removing it's phone number)
  pictureUrl: AWSURL | null;
}

export interface GetBusinessByHandle_businessByHandle_business_readOnlyAdmins {
  __typename: "User";
  userId: string;
  name: string | null;
  phoneNumber: AWSPhone | null;  // User phoneNumber is optional because the user could "take" the phoneNumber of another user (removing it's phone number)
  pictureUrl: AWSURL | null;
}

export interface GetBusinessByHandle_businessByHandle_business {
  __typename: "Business";
  businessId: string;
  businessHandle: string;
  name: string;
  description: string | null;
  category: string;
  phoneNumber: AWSPhone;
  timezone: string;
  enabled: boolean;
  cancellationPolicy: string | null;
  weeklyAvailability: GetBusinessByHandle_businessByHandle_business_weeklyAvailability[];
  paymentMethods: PaymentMethod[];
  website: AWSURL | null;
  email: AWSEmail | null;
  instagramProfileUrl: AWSURL | null;
  facebookProfileUrl: AWSURL | null;
  twitterProfileUrl: AWSURL | null;
  pictureUrl: AWSURL | null;
  backgroundPictureUrl: AWSURL | null;
  isDemo: boolean;
  _geoloc: GetBusinessByHandle_businessByHandle_business__geoloc;
  address: GetBusinessByHandle_businessByHandle_business_address;
  mercadoPagoLinked: boolean;                                                                         // This query can be used by any user (kept public to allow checking it before displaying the services) Returns true if the connection with a Mercado Pago account was set and can be used to require payments on services
  resources: GetBusinessByHandle_businessByHandle_business_resources[];
  services: GetBusinessByHandle_businessByHandle_business_services[];
  mercadoPagoLinkedUser: GetBusinessByHandle_businessByHandle_business_mercadoPagoLinkedUser | null;  // Get the Mercado Pago user account that was linked or null if no user account was linked. - Only admins and super users can execute this query
  admins: GetBusinessByHandle_businessByHandle_business_admins[];                                     // - Only admins and super users can execute this query
  readOnlyAdmins: GetBusinessByHandle_businessByHandle_business_readOnlyAdmins[];                     // - Only admins and super users can execute this query
}

export interface GetBusinessByHandle_businessByHandle {
  __typename: "BusinessHandle";
  business: GetBusinessByHandle_businessByHandle_business;
}

export interface GetBusinessByHandle {
  businessByHandle: GetBusinessByHandle_businessByHandle | null;  // Get business handle. Returns null if not found
}

export interface GetBusinessByHandleVariables {
  businessHandle: string;
  fetchMPLinkedUser?: boolean | null;
  fetchAdmins?: boolean | null;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBusinessExports
// ====================================================

export interface GetBusinessExports_business_exports {
  __typename: "Export";
  createdAt: AWSTimestamp;
  exportId: string;
  link: AWSURL | null;  // link will be available if the status = COMPLETED
  since: AWSTimestamp;
  until: AWSTimestamp;
  status: ExportStatus;
  ttl: AWSTimestamp;
}

export interface GetBusinessExports_business {
  __typename: "Business";
  exports: GetBusinessExports_business_exports[] | null;  // Exports will be deleted automatically after 1 month. This query will return the latest exports (the actual number of exports returned is not defined, will be a best effort approach) - Only admins and super users can execute this query
}

export interface GetBusinessExports {
  business: GetBusinessExports_business | null;  // Returns null if not found
}

export interface GetBusinessExportsVariables {
  businessId: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBusinessMercadoPagoLinkStatus
// ====================================================

export interface GetBusinessMercadoPagoLinkStatus_business {
  __typename: "Business";
  mercadoPagoLinked: boolean;  // This query can be used by any user (kept public to allow checking it before displaying the services) Returns true if the connection with a Mercado Pago account was set and can be used to require payments on services
}

export interface GetBusinessMercadoPagoLinkStatus {
  business: GetBusinessMercadoPagoLinkStatus_business | null;  // Returns null if not found
}

export interface GetBusinessMercadoPagoLinkStatusVariables {
  businessId: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBusinessNotifications
// ====================================================

export interface GetBusinessNotifications {
  businessNotifications: AWSJSON | null;  // Map of businessId to Notifications object (can't be typed on GraphQL) Returns null or empty json object if there is no business notification configured.
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBusinessResources
// ====================================================

export interface GetBusinessResources_business_resources_overlappingRequirements {
  __typename: "OverlappingRequirements";
  sameInterval: boolean;  // All overlappoing appointments must have the same "since" and "until" interval
  sameService: boolean;   // All overlappoing appointments must be from the same service
}

export interface GetBusinessResources_business_resources_weeklyAvailability {
  __typename: "AvailabilitySpot";
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  weekday: Weekday | null;
}

export interface GetBusinessResources_business_resources {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  description: string | null;
  enabled: boolean;
  name: string;
  pictureUrl: AWSURL | null;
  labels: string[];
  resourceType: ResourceType;
  overlappingRequirements: GetBusinessResources_business_resources_overlappingRequirements;
  weeklyAvailability: GetBusinessResources_business_resources_weeklyAvailability[];
}

export interface GetBusinessResources_business {
  __typename: "Business";
  resources: GetBusinessResources_business_resources[];
}

export interface GetBusinessResources {
  business: GetBusinessResources_business | null;  // Returns null if not found
}

export interface GetBusinessResourcesVariables {
  businessId: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBusinessServices
// ====================================================

export interface GetBusinessServices_business_services_weeklyAvailability {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
}

export interface GetBusinessServices_business_services_weeklyAvailabilityByIntervals {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
}

export interface GetBusinessServices_business_services {
  __typename: "Service";
  enabled: boolean;
  serviceId: string;
  name: string;
  description: string | null;
  price: number | null;
  requiresConfirmation: boolean;
  durationMinutes: number;                                                                               // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  resourcesId: string[];
  minAnticipationHours: number;
  maxAnticipationDays: number;
  concurrency: number;
  appointmentsFrequencyMinutes: number;
  requiredPayment: number;                                                                               // Amount to charge the user to confirm the appointment. Zero if a payment is not required to confirm the appointments (can't be combined with 'requiresConfirmation')
  weeklyAvailability: GetBusinessServices_business_services_weeklyAvailability[];
  weeklyAvailabilityByIntervals: GetBusinessServices_business_services_weeklyAvailabilityByIntervals[];  // Only to store and retrieve the same data the user provided, duplicates info from weeklyAvailability (not used internally)
}

export interface GetBusinessServices_business {
  __typename: "Business";
  services: GetBusinessServices_business_services[];
}

export interface GetBusinessServices {
  business: GetBusinessServices_business | null;  // Returns null if not found
}

export interface GetBusinessServicesVariables {
  businessId: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBusinessSubscriptionsUsage
// ====================================================

export interface GetBusinessSubscriptionsUsage_one_subscriptionUsage_plan {
  __typename: "SubscriptionPlan";
  appointmentsFreeTier: number | null;
  appointmentsPerBlock: number | null;
  blockAmountInCents: number | null;
}

export interface GetBusinessSubscriptionsUsage_one_subscriptionUsage {
  __typename: "AdminSubscriptionUsage";
  amountInCents: number | null;
  currency: string | null;
  paid: boolean | null;
  plan: GetBusinessSubscriptionsUsage_one_subscriptionUsage_plan | null;
  requestedAppointments: number | null;
}

export interface GetBusinessSubscriptionsUsage_one {
  __typename: "Business";
  subscriptionUsage: GetBusinessSubscriptionsUsage_one_subscriptionUsage | null;  // Returns the number of appointments requested to the business on one month. - Month: 1 (January) to 12 (December) - Only admins and super users can execute this query
}

export interface GetBusinessSubscriptionsUsage_two_subscriptionUsage_plan {
  __typename: "SubscriptionPlan";
  appointmentsFreeTier: number | null;
  appointmentsPerBlock: number | null;
  blockAmountInCents: number | null;
}

export interface GetBusinessSubscriptionsUsage_two_subscriptionUsage {
  __typename: "AdminSubscriptionUsage";
  amountInCents: number | null;
  currency: string | null;
  paid: boolean | null;
  plan: GetBusinessSubscriptionsUsage_two_subscriptionUsage_plan | null;
  requestedAppointments: number | null;
}

export interface GetBusinessSubscriptionsUsage_two {
  __typename: "Business";
  subscriptionUsage: GetBusinessSubscriptionsUsage_two_subscriptionUsage | null;  // Returns the number of appointments requested to the business on one month. - Month: 1 (January) to 12 (December) - Only admins and super users can execute this query
}

export interface GetBusinessSubscriptionsUsage_three_subscriptionUsage_plan {
  __typename: "SubscriptionPlan";
  appointmentsFreeTier: number | null;
  appointmentsPerBlock: number | null;
  blockAmountInCents: number | null;
}

export interface GetBusinessSubscriptionsUsage_three_subscriptionUsage {
  __typename: "AdminSubscriptionUsage";
  amountInCents: number | null;
  currency: string | null;
  paid: boolean | null;
  plan: GetBusinessSubscriptionsUsage_three_subscriptionUsage_plan | null;
  requestedAppointments: number | null;
}

export interface GetBusinessSubscriptionsUsage_three {
  __typename: "Business";
  subscriptionUsage: GetBusinessSubscriptionsUsage_three_subscriptionUsage | null;  // Returns the number of appointments requested to the business on one month. - Month: 1 (January) to 12 (December) - Only admins and super users can execute this query
}

export interface GetBusinessSubscriptionsUsage_four_subscriptionUsage_plan {
  __typename: "SubscriptionPlan";
  appointmentsFreeTier: number | null;
  appointmentsPerBlock: number | null;
  blockAmountInCents: number | null;
}

export interface GetBusinessSubscriptionsUsage_four_subscriptionUsage {
  __typename: "AdminSubscriptionUsage";
  amountInCents: number | null;
  currency: string | null;
  paid: boolean | null;
  plan: GetBusinessSubscriptionsUsage_four_subscriptionUsage_plan | null;
  requestedAppointments: number | null;
}

export interface GetBusinessSubscriptionsUsage_four {
  __typename: "Business";
  subscriptionUsage: GetBusinessSubscriptionsUsage_four_subscriptionUsage | null;  // Returns the number of appointments requested to the business on one month. - Month: 1 (January) to 12 (December) - Only admins and super users can execute this query
}

export interface GetBusinessSubscriptionsUsage_five_subscriptionUsage_plan {
  __typename: "SubscriptionPlan";
  appointmentsFreeTier: number | null;
  appointmentsPerBlock: number | null;
  blockAmountInCents: number | null;
}

export interface GetBusinessSubscriptionsUsage_five_subscriptionUsage {
  __typename: "AdminSubscriptionUsage";
  amountInCents: number | null;
  currency: string | null;
  paid: boolean | null;
  plan: GetBusinessSubscriptionsUsage_five_subscriptionUsage_plan | null;
  requestedAppointments: number | null;
}

export interface GetBusinessSubscriptionsUsage_five {
  __typename: "Business";
  subscriptionUsage: GetBusinessSubscriptionsUsage_five_subscriptionUsage | null;  // Returns the number of appointments requested to the business on one month. - Month: 1 (January) to 12 (December) - Only admins and super users can execute this query
}

export interface GetBusinessSubscriptionsUsage_six_subscriptionUsage_plan {
  __typename: "SubscriptionPlan";
  appointmentsFreeTier: number | null;
  appointmentsPerBlock: number | null;
  blockAmountInCents: number | null;
}

export interface GetBusinessSubscriptionsUsage_six_subscriptionUsage {
  __typename: "AdminSubscriptionUsage";
  amountInCents: number | null;
  currency: string | null;
  paid: boolean | null;
  plan: GetBusinessSubscriptionsUsage_six_subscriptionUsage_plan | null;
  requestedAppointments: number | null;
}

export interface GetBusinessSubscriptionsUsage_six {
  __typename: "Business";
  subscriptionUsage: GetBusinessSubscriptionsUsage_six_subscriptionUsage | null;  // Returns the number of appointments requested to the business on one month. - Month: 1 (January) to 12 (December) - Only admins and super users can execute this query
}

export interface GetBusinessSubscriptionsUsage {
  one: GetBusinessSubscriptionsUsage_one | null;      // Returns null if not found
  two: GetBusinessSubscriptionsUsage_two | null;      // Returns null if not found
  three: GetBusinessSubscriptionsUsage_three | null;  // Returns null if not found
  four: GetBusinessSubscriptionsUsage_four | null;    // Returns null if not found
  five: GetBusinessSubscriptionsUsage_five | null;    // Returns null if not found
  six: GetBusinessSubscriptionsUsage_six | null;      // Returns null if not found
}

export interface GetBusinessSubscriptionsUsageVariables {
  businessId: string;
  month1: number;
  year1: number;
  month2: number;
  year2: number;
  month3: number;
  year3: number;
  month4: number;
  year4: number;
  month5: number;
  year5: number;
  month6: number;
  year6: number;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetExceptionsForResource
// ====================================================

export interface GetExceptionsForResource_resource_exceptions_items {
  __typename: "Exception";
  businessId: string;
  resourceId: string;
  since: AWSTimestamp;  // Inclusive
  until: AWSTimestamp;  // Exclusive
}

export interface GetExceptionsForResource_resource_exceptions {
  __typename: "ExceptionsConnection";
  items: GetExceptionsForResource_resource_exceptions_items[];
  nextToken: string | null;
}

export interface GetExceptionsForResource_resource {
  __typename: "Resource";
  exceptions: GetExceptionsForResource_resource_exceptions;  // Returns recource's exceptions between since (inclusive) and until (exclusive) - Only admins and super users can execute this query
}

export interface GetExceptionsForResource {
  resource: GetExceptionsForResource_resource | null;  // Returns null if not found
}

export interface GetExceptionsForResourceVariables {
  businessId: string;
  resourceId: string;
  since: AWSTimestamp;
  until: AWSTimestamp;
  limit?: number | null;
  nextToken?: string | null;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetServiceAnticipation
// ====================================================

export interface GetServiceAnticipation_service_anticipation {
  __typename: "Anticipation";
  min: AWSTimestamp;  // Closest point in time the service allows to request an appointment (not rounded). Only appointments with `appointment.since >= min` can be requested (an error will be returned otherwise).
  max: AWSTimestamp;  // Latest point in time the service allows to request an appointment (rounded to the start of the day on the business' timezone). Only appointments with `appointment.since < max` can be requested (an error will be returned otherwise).
}

export interface GetServiceAnticipation_service {
  __typename: "Service";
  serviceId: string;
  anticipation: GetServiceAnticipation_service_anticipation;  // Returns the anticipation boundaries for service's appointments. This query is idempotent.
}

export interface GetServiceAnticipation {
  service: GetServiceAnticipation_service | null;  // Returns null if not found
}

export interface GetServiceAnticipationVariables {
  businessId: string;
  serviceId: string;
  now: AWSTimestamp;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserNotifications
// ====================================================

export interface GetUserNotifications_notifications {
  __typename: "Notifications";
  email: boolean;
  push: boolean;
  sms: boolean;
}

export interface GetUserNotifications {
  notifications: GetUserNotifications_notifications;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWeekAvailableSpots
// ====================================================

export interface GetWeekAvailableSpots_service_weekAvailableSpots_resources {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  name: string;
  pictureUrl: AWSURL | null;
}

export interface GetWeekAvailableSpots_service_weekAvailableSpots {
  __typename: "Spot";
  durationMinutes: number;                                                  // (until - since) in minutes.
  resources: GetWeekAvailableSpots_service_weekAvailableSpots_resources[];  // Resources available to fulfill this service at this time
  since: AWSTimestamp;                                                      // Inclusive.
  until: AWSTimestamp;                                                      // Exclusive. Could be in a different day or week than `since`.
}

export interface GetWeekAvailableSpots_service {
  __typename: "Service";
  weekAvailableSpots: GetWeekAvailableSpots_service_weekAvailableSpots[];  // One week of appointment spots starting from the first sunday before `since` at 00:00 (or in the same day if `since` is sunday) and until the next sunday at the same time (not inclusive) using business' timezone. The spots could end past the end of the week, but all of them will start within the current week. - Null resourceId means all business' resources.
}

export interface GetWeekAvailableSpots {
  service: GetWeekAvailableSpots_service | null;  // Returns null if not found
}

export interface GetWeekAvailableSpotsVariables {
  businessId: string;
  serviceId: string;
  resourceId?: string | null;
  since: AWSTimestamp;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWeekAvailableSpotsAdmin
// ====================================================

export interface GetWeekAvailableSpotsAdmin_service_weekAvailableSpotsAdmin_resources {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  name: string;
  pictureUrl: AWSURL | null;
}

export interface GetWeekAvailableSpotsAdmin_service_weekAvailableSpotsAdmin_appointments_business {
  __typename: "Business";
  businessId: string;
}

export interface GetWeekAvailableSpotsAdmin_service_weekAvailableSpotsAdmin_appointments_resource {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
}

export interface GetWeekAvailableSpotsAdmin_service_weekAvailableSpotsAdmin_appointments {
  __typename: "AdminAppointment";
  userId: string;
  createdAt: AWSTimestamp;
  business: GetWeekAvailableSpotsAdmin_service_weekAvailableSpotsAdmin_appointments_business;
  resource: GetWeekAvailableSpotsAdmin_service_weekAvailableSpotsAdmin_appointments_resource;
  since: AWSTimestamp;
  status: AppointmentStatus;
  until: AWSTimestamp;
}

export interface GetWeekAvailableSpotsAdmin_service_weekAvailableSpotsAdmin {
  __typename: "AdminSpot";
  durationMinutes: number;                                                                  // (until - since) in minutes.
  resources: GetWeekAvailableSpotsAdmin_service_weekAvailableSpotsAdmin_resources[];        // Resources available to fulfill this service at this time
  since: AWSTimestamp;                                                                      // Inclusive.
  until: AWSTimestamp;                                                                      // Exclusive. Could be in a different day or week than `since`.
  appointments: GetWeekAvailableSpotsAdmin_service_weekAvailableSpotsAdmin_appointments[];  // Only admins and super users can request this - Doesn't include canceled appointments (only pending and confirmed)
}

export interface GetWeekAvailableSpotsAdmin_service {
  __typename: "Service";
  weekAvailableSpotsAdmin: GetWeekAvailableSpotsAdmin_service_weekAvailableSpotsAdmin[];  // One week of appointment spots starting from the first sunday before `since` at 00:00 (or in the same day if `since` is sunday) and until the next sunday at the same time (not inclusive) using business' timezone. The spots could end past the end of the week, but all of them will start within the current week. - Null resourceId means all business' resources. - Only admins and super users can execute this query - Spot Appointments: only includes appointments that will be active before the spot starts
}

export interface GetWeekAvailableSpotsAdmin {
  service: GetWeekAvailableSpotsAdmin_service | null;  // Returns null if not found
}

export interface GetWeekAvailableSpotsAdminVariables {
  businessId: string;
  serviceId: string;
  resourceId?: string | null;
  since: AWSTimestamp;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMe
// ====================================================

export interface GetMe_me_businessesV2_business_resources {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  name: string;
  pictureUrl: AWSURL | null;
  enabled: boolean;
}

export interface GetMe_me_businessesV2_business {
  __typename: "Business";
  businessId: string;
  name: string;
  pictureUrl: AWSURL | null;
  timezone: string;
  businessHandle: string;
  email: AWSEmail | null;
  enabled: boolean;
  mercadoPagoLinked: boolean;  // This query can be used by any user (kept public to allow checking it before displaying the services) Returns true if the connection with a Mercado Pago account was set and can be used to require payments on services
  resources: GetMe_me_businessesV2_business_resources[];
}

export interface GetMe_me_businessesV2 {
  __typename: "UserBusiness";
  business: GetMe_me_businessesV2_business;
  readOnly: boolean;  // false if the user as an admin can make updates to the appointments or configuration of the business
}

export interface GetMe_me_favoriteBusinesses {
  __typename: "Business";
  businessId: string;
  businessHandle: string;
  name: string;
  pictureUrl: AWSURL | null;
  isDemo: boolean;
  enabled: boolean;
}

export interface GetMe_me {
  __typename: "User";
  userId: string;
  email: AWSEmail | null;                             // User email is optional because businesses can create users with only the phone number
  name: string | null;
  phoneNumber: AWSPhone | null;                       // User phoneNumber is optional because the user could "take" the phoneNumber of another user (removing it's phone number)
  pictureUrl: AWSURL | null;
  businessesV2: GetMe_me_businessesV2[];              // Businesses where the users is an admin or a read-only admin - Only roots or the logged in user can ask for user's businesses
  favoriteBusinesses: GetMe_me_favoriteBusinesses[];  // From the latest 10 appointments, gets at most 6 distinct Businesses
}

export interface GetMe {
  me: GetMe_me | null;  // Updates current user metadata Returns null if the user didn't verified email or phone number is not set (phone number can be moved to another user)
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: Address
// ====================================================

export interface Address {
  __typename: "Address";
  country: string;
  city: string;
  street: string;
  number: string;
  zipcode: string;
  directions: string | null;  // Floor, department, etc.
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminAppointment
// ====================================================

export interface AdminAppointment_business {
  __typename: "Business";
  businessId: string;
  timezone: string;
  name: string;
}

export interface AdminAppointment_resource {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  name: string;
  pictureUrl: AWSURL | null;
}

export interface AdminAppointment_service {
  __typename: "Service";
  serviceId: string;
  name: string;
  price: number | null;
}

export interface AdminAppointment_user {
  __typename: "User";
  userId: string;
  email: AWSEmail | null;        // User email is optional because businesses can create users with only the phone number
  name: string | null;
  phoneNumber: AWSPhone | null;  // User phoneNumber is optional because the user could "take" the phoneNumber of another user (removing it's phone number)
  pictureUrl: AWSURL | null;
}

export interface AdminAppointment_payment {
  __typename: "Payment";
  link: AWSURL;                         // This link allows the user to pay for the appointment
  linkExpiration: AWSTimestamp;
  paymentId: string;
  mercadoPagoPaymentId: string | null;  // null if not payed
  externalReference: string;
  paidAt: AWSTimestamp | null;          // null if not payed
  price: number;
}

export interface AdminAppointment {
  __typename: "AdminAppointment";
  business: AdminAppointment_business;
  createdAt: AWSTimestamp;
  description: string | null;
  durationMinutes: number;
  price: number | null;
  resource: AdminAppointment_resource;
  service: AdminAppointment_service;
  since: AWSTimestamp;
  status: AppointmentStatus;
  statusCause: AppointmentStatusCause;       // Explain the cause (user, admin or payment) of why is in the current status
  cancellationMessage: string | null;
  until: AWSTimestamp;
  user: AdminAppointment_user;
  createdByUserId: string;
  payment: AdminAppointment_payment | null;  // If present, the appointment requires a payment to be confirmed
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminSubscriptionUsage
// ====================================================

export interface AdminSubscriptionUsage_plan {
  __typename: "SubscriptionPlan";
  appointmentsFreeTier: number | null;
  appointmentsPerBlock: number | null;
  blockAmountInCents: number | null;
}

export interface AdminSubscriptionUsage {
  __typename: "AdminSubscriptionUsage";
  amountInCents: number | null;
  currency: string | null;
  paid: boolean | null;
  plan: AdminSubscriptionUsage_plan | null;
  requestedAppointments: number | null;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppointmentCreatedBy
// ====================================================

export interface AppointmentCreatedBy {
  __typename: "User";
  userId: string;
  name: string | null;
  pictureUrl: AWSURL | null;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppointmentPayment
// ====================================================

export interface AppointmentPayment {
  __typename: "Payment";
  link: AWSURL;                         // This link allows the user to pay for the appointment
  linkExpiration: AWSTimestamp;
  paymentId: string;
  mercadoPagoPaymentId: string | null;  // null if not payed
  externalReference: string;
  paidAt: AWSTimestamp | null;          // null if not payed
  price: number;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BaseBusiness
// ====================================================

export interface BaseBusiness_weeklyAvailability {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
}

export interface BaseBusiness__geoloc {
  __typename: "GeoLoc";
  lng: number;
  lat: number;
}

export interface BaseBusiness_address {
  __typename: "Address";
  country: string;
  city: string;
  street: string;
  number: string;
  zipcode: string;
  directions: string | null;  // Floor, department, etc.
}

export interface BaseBusiness {
  __typename: "Business";
  businessId: string;
  businessHandle: string;
  name: string;
  description: string | null;
  category: string;
  phoneNumber: AWSPhone;
  timezone: string;
  enabled: boolean;
  cancellationPolicy: string | null;
  weeklyAvailability: BaseBusiness_weeklyAvailability[];
  paymentMethods: PaymentMethod[];
  website: AWSURL | null;
  email: AWSEmail | null;
  instagramProfileUrl: AWSURL | null;
  facebookProfileUrl: AWSURL | null;
  twitterProfileUrl: AWSURL | null;
  pictureUrl: AWSURL | null;
  backgroundPictureUrl: AWSURL | null;
  isDemo: boolean;
  _geoloc: BaseBusiness__geoloc;
  address: BaseBusiness_address;
  mercadoPagoLinked: boolean;  // This query can be used by any user (kept public to allow checking it before displaying the services) Returns true if the connection with a Mercado Pago account was set and can be used to require payments on services
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BaseResource
// ====================================================

export interface BaseResource_overlappingRequirements {
  __typename: "OverlappingRequirements";
  sameInterval: boolean;  // All overlappoing appointments must have the same "since" and "until" interval
  sameService: boolean;   // All overlappoing appointments must be from the same service
}

export interface BaseResource_weeklyAvailability {
  __typename: "AvailabilitySpot";
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  weekday: Weekday | null;
}

export interface BaseResource {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  description: string | null;
  enabled: boolean;
  name: string;
  pictureUrl: AWSURL | null;
  labels: string[];
  resourceType: ResourceType;
  overlappingRequirements: BaseResource_overlappingRequirements;
  weeklyAvailability: BaseResource_weeklyAvailability[];
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BaseService
// ====================================================

export interface BaseService_weeklyAvailability {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
}

export interface BaseService_weeklyAvailabilityByIntervals {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
}

export interface BaseService {
  __typename: "Service";
  enabled: boolean;
  serviceId: string;
  name: string;
  description: string | null;
  price: number | null;
  requiresConfirmation: boolean;
  durationMinutes: number;                                                     // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  resourcesId: string[];
  minAnticipationHours: number;
  maxAnticipationDays: number;
  concurrency: number;
  appointmentsFrequencyMinutes: number;
  requiredPayment: number;                                                     // Amount to charge the user to confirm the appointment. Zero if a payment is not required to confirm the appointments (can't be combined with 'requiresConfirmation')
  weeklyAvailability: BaseService_weeklyAvailability[];
  weeklyAvailabilityByIntervals: BaseService_weeklyAvailabilityByIntervals[];  // Only to store and retrieve the same data the user provided, duplicates info from weeklyAvailability (not used internally)
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BusinessAppointment
// ====================================================

export interface BusinessAppointment_business_address {
  __typename: "Address";
  country: string;
  city: string;
  street: string;
  number: string;
  zipcode: string;
  directions: string | null;  // Floor, department, etc.
}

export interface BusinessAppointment_business {
  __typename: "Business";
  businessId: string;
  timezone: string;
  name: string;
  address: BusinessAppointment_business_address;
}

export interface BusinessAppointment_resource {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  name: string;
  pictureUrl: AWSURL | null;
}

export interface BusinessAppointment_service {
  __typename: "Service";
  serviceId: string;
  name: string;
  price: number | null;
  requiredPayment: number;  // Amount to charge the user to confirm the appointment. Zero if a payment is not required to confirm the appointments (can't be combined with 'requiresConfirmation')
}

export interface BusinessAppointment_user {
  __typename: "User";
  userId: string;
  email: AWSEmail | null;        // User email is optional because businesses can create users with only the phone number
  name: string | null;
  phoneNumber: AWSPhone | null;  // User phoneNumber is optional because the user could "take" the phoneNumber of another user (removing it's phone number)
  pictureUrl: AWSURL | null;
}

export interface BusinessAppointment_createdBy {
  __typename: "User";
  userId: string;
  name: string | null;
  pictureUrl: AWSURL | null;
}

export interface BusinessAppointment_payment {
  __typename: "Payment";
  link: AWSURL;                         // This link allows the user to pay for the appointment
  linkExpiration: AWSTimestamp;
  paymentId: string;
  mercadoPagoPaymentId: string | null;  // null if not payed
  externalReference: string;
  paidAt: AWSTimestamp | null;          // null if not payed
  price: number;
}

export interface BusinessAppointment {
  __typename: "BusinessAppointment";
  business: BusinessAppointment_business;
  createdAt: AWSTimestamp;
  description: string | null;
  durationMinutes: number;
  price: number | null;
  resource: BusinessAppointment_resource;
  service: BusinessAppointment_service;
  since: AWSTimestamp;
  status: AppointmentStatus;
  statusCause: AppointmentStatusCause;          // Explain the cause (user, admin or payment) of why is in the current status
  cancellationMessage: string | null;
  until: AWSTimestamp;
  user: BusinessAppointment_user;
  createdBy: BusinessAppointment_createdBy;
  payment: BusinessAppointment_payment | null;  // If present, the appointment requires a payment to be confirmed
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: Business
// ====================================================

export interface Business_weeklyAvailability {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
}

export interface Business__geoloc {
  __typename: "GeoLoc";
  lng: number;
  lat: number;
}

export interface Business_address {
  __typename: "Address";
  country: string;
  city: string;
  street: string;
  number: string;
  zipcode: string;
  directions: string | null;  // Floor, department, etc.
}

export interface Business_resources_overlappingRequirements {
  __typename: "OverlappingRequirements";
  sameInterval: boolean;  // All overlappoing appointments must have the same "since" and "until" interval
  sameService: boolean;   // All overlappoing appointments must be from the same service
}

export interface Business_resources_weeklyAvailability {
  __typename: "AvailabilitySpot";
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  weekday: Weekday | null;
}

export interface Business_resources {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  description: string | null;
  enabled: boolean;
  name: string;
  pictureUrl: AWSURL | null;
  labels: string[];
  resourceType: ResourceType;
  overlappingRequirements: Business_resources_overlappingRequirements;
  weeklyAvailability: Business_resources_weeklyAvailability[];
}

export interface Business_services_weeklyAvailability {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
}

export interface Business_services_weeklyAvailabilityByIntervals {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
}

export interface Business_services {
  __typename: "Service";
  enabled: boolean;
  serviceId: string;
  name: string;
  description: string | null;
  price: number | null;
  requiresConfirmation: boolean;
  durationMinutes: number;                                                           // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  resourcesId: string[];
  minAnticipationHours: number;
  maxAnticipationDays: number;
  concurrency: number;
  appointmentsFrequencyMinutes: number;
  requiredPayment: number;                                                           // Amount to charge the user to confirm the appointment. Zero if a payment is not required to confirm the appointments (can't be combined with 'requiresConfirmation')
  weeklyAvailability: Business_services_weeklyAvailability[];
  weeklyAvailabilityByIntervals: Business_services_weeklyAvailabilityByIntervals[];  // Only to store and retrieve the same data the user provided, duplicates info from weeklyAvailability (not used internally)
}

export interface Business_mercadoPagoLinkedUser {
  __typename: "MercadoPagoUser";
  firstName: string | null;
  lastName: string | null;
  nickname: string | null;
  profilePicture: AWSURL | null;
  mercadoPagoUserId: string;
  countryCode: string | null;
  createdAt: AWSTimestamp;
  updatedAt: AWSTimestamp;
}

export interface Business_admins {
  __typename: "User";
  userId: string;
  name: string | null;
  phoneNumber: AWSPhone | null;  // User phoneNumber is optional because the user could "take" the phoneNumber of another user (removing it's phone number)
  pictureUrl: AWSURL | null;
}

export interface Business_readOnlyAdmins {
  __typename: "User";
  userId: string;
  name: string | null;
  phoneNumber: AWSPhone | null;  // User phoneNumber is optional because the user could "take" the phoneNumber of another user (removing it's phone number)
  pictureUrl: AWSURL | null;
}

export interface Business {
  __typename: "Business";
  businessId: string;
  businessHandle: string;
  name: string;
  description: string | null;
  category: string;
  phoneNumber: AWSPhone;
  timezone: string;
  enabled: boolean;
  cancellationPolicy: string | null;
  weeklyAvailability: Business_weeklyAvailability[];
  paymentMethods: PaymentMethod[];
  website: AWSURL | null;
  email: AWSEmail | null;
  instagramProfileUrl: AWSURL | null;
  facebookProfileUrl: AWSURL | null;
  twitterProfileUrl: AWSURL | null;
  pictureUrl: AWSURL | null;
  backgroundPictureUrl: AWSURL | null;
  isDemo: boolean;
  _geoloc: Business__geoloc;
  address: Business_address;
  mercadoPagoLinked: boolean;                                    // This query can be used by any user (kept public to allow checking it before displaying the services) Returns true if the connection with a Mercado Pago account was set and can be used to require payments on services
  resources: Business_resources[];
  services: Business_services[];
  mercadoPagoLinkedUser: Business_mercadoPagoLinkedUser | null;  // Get the Mercado Pago user account that was linked or null if no user account was linked. - Only admins and super users can execute this query
  admins: Business_admins[];                                     // - Only admins and super users can execute this query
  readOnlyAdmins: Business_readOnlyAdmins[];                     // - Only admins and super users can execute this query
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: Exception
// ====================================================

export interface Exception {
  __typename: "Exception";
  businessId: string;
  resourceId: string;
  since: AWSTimestamp;  // Inclusive
  until: AWSTimestamp;  // Exclusive
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FavouriteBusiness
// ====================================================

export interface FavouriteBusiness {
  __typename: "Business";
  businessId: string;
  businessHandle: string;
  name: string;
  pictureUrl: AWSURL | null;
  isDemo: boolean;
  enabled: boolean;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FullUser
// ====================================================

export interface FullUser_businessesV2_business_resources {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  name: string;
  pictureUrl: AWSURL | null;
  enabled: boolean;
}

export interface FullUser_businessesV2_business {
  __typename: "Business";
  businessId: string;
  name: string;
  pictureUrl: AWSURL | null;
  timezone: string;
  businessHandle: string;
  email: AWSEmail | null;
  enabled: boolean;
  mercadoPagoLinked: boolean;  // This query can be used by any user (kept public to allow checking it before displaying the services) Returns true if the connection with a Mercado Pago account was set and can be used to require payments on services
  resources: FullUser_businessesV2_business_resources[];
}

export interface FullUser_businessesV2 {
  __typename: "UserBusiness";
  business: FullUser_businessesV2_business;
  readOnly: boolean;  // false if the user as an admin can make updates to the appointments or configuration of the business
}

export interface FullUser_favoriteBusinesses {
  __typename: "Business";
  businessId: string;
  businessHandle: string;
  name: string;
  pictureUrl: AWSURL | null;
  isDemo: boolean;
  enabled: boolean;
}

export interface FullUser {
  __typename: "User";
  userId: string;
  email: AWSEmail | null;                             // User email is optional because businesses can create users with only the phone number
  name: string | null;
  phoneNumber: AWSPhone | null;                       // User phoneNumber is optional because the user could "take" the phoneNumber of another user (removing it's phone number)
  pictureUrl: AWSURL | null;
  businessesV2: FullUser_businessesV2[];              // Businesses where the users is an admin or a read-only admin - Only roots or the logged in user can ask for user's businesses
  favoriteBusinesses: FullUser_favoriteBusinesses[];  // From the latest 10 appointments, gets at most 6 distinct Businesses
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: Notifications
// ====================================================

export interface Notifications {
  __typename: "Notifications";
  email: boolean;
  push: boolean;
  sms: boolean;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PaymentMethods
// ====================================================

export interface PaymentMethods {
  __typename: "Business";
  paymentMethods: PaymentMethod[];
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: Spot
// ====================================================

export interface Spot_resources {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  name: string;
  pictureUrl: AWSURL | null;
}

export interface Spot {
  __typename: "Spot";
  durationMinutes: number;      // (until - since) in minutes.
  resources: Spot_resources[];  // Resources available to fulfill this service at this time
  since: AWSTimestamp;          // Inclusive.
  until: AWSTimestamp;          // Exclusive. Could be in a different day or week than `since`.
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserAdministrator
// ====================================================

export interface UserAdministrator {
  __typename: "User";
  userId: string;
  name: string | null;
  phoneNumber: AWSPhone | null;  // User phoneNumber is optional because the user could "take" the phoneNumber of another user (removing it's phone number)
  pictureUrl: AWSURL | null;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserAppointment
// ====================================================

export interface UserAppointment_business_weeklyAvailability {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
}

export interface UserAppointment_business__geoloc {
  __typename: "GeoLoc";
  lng: number;
  lat: number;
}

export interface UserAppointment_business_address {
  __typename: "Address";
  country: string;
  city: string;
  street: string;
  number: string;
  zipcode: string;
  directions: string | null;  // Floor, department, etc.
}

export interface UserAppointment_business {
  __typename: "Business";
  businessId: string;
  businessHandle: string;
  name: string;
  description: string | null;
  category: string;
  phoneNumber: AWSPhone;
  timezone: string;
  enabled: boolean;
  cancellationPolicy: string | null;
  weeklyAvailability: UserAppointment_business_weeklyAvailability[];
  paymentMethods: PaymentMethod[];
  website: AWSURL | null;
  email: AWSEmail | null;
  instagramProfileUrl: AWSURL | null;
  facebookProfileUrl: AWSURL | null;
  twitterProfileUrl: AWSURL | null;
  pictureUrl: AWSURL | null;
  backgroundPictureUrl: AWSURL | null;
  isDemo: boolean;
  _geoloc: UserAppointment_business__geoloc;
  address: UserAppointment_business_address;
  mercadoPagoLinked: boolean;  // This query can be used by any user (kept public to allow checking it before displaying the services) Returns true if the connection with a Mercado Pago account was set and can be used to require payments on services
}

export interface UserAppointment_service_weeklyAvailability {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
}

export interface UserAppointment_service_weeklyAvailabilityByIntervals {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
}

export interface UserAppointment_service {
  __typename: "Service";
  enabled: boolean;
  serviceId: string;
  name: string;
  description: string | null;
  price: number | null;
  requiresConfirmation: boolean;
  durationMinutes: number;                                                                 // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  resourcesId: string[];
  minAnticipationHours: number;
  maxAnticipationDays: number;
  concurrency: number;
  appointmentsFrequencyMinutes: number;
  requiredPayment: number;                                                                 // Amount to charge the user to confirm the appointment. Zero if a payment is not required to confirm the appointments (can't be combined with 'requiresConfirmation')
  weeklyAvailability: UserAppointment_service_weeklyAvailability[];
  weeklyAvailabilityByIntervals: UserAppointment_service_weeklyAvailabilityByIntervals[];  // Only to store and retrieve the same data the user provided, duplicates info from weeklyAvailability (not used internally)
}

export interface UserAppointment_resource_overlappingRequirements {
  __typename: "OverlappingRequirements";
  sameInterval: boolean;  // All overlappoing appointments must have the same "since" and "until" interval
  sameService: boolean;   // All overlappoing appointments must be from the same service
}

export interface UserAppointment_resource_weeklyAvailability {
  __typename: "AvailabilitySpot";
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
  weekday: Weekday | null;
}

export interface UserAppointment_resource {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  description: string | null;
  enabled: boolean;
  name: string;
  pictureUrl: AWSURL | null;
  labels: string[];
  resourceType: ResourceType;
  overlappingRequirements: UserAppointment_resource_overlappingRequirements;
  weeklyAvailability: UserAppointment_resource_weeklyAvailability[];
}

export interface UserAppointment_payment {
  __typename: "Payment";
  link: AWSURL;                         // This link allows the user to pay for the appointment
  linkExpiration: AWSTimestamp;
  paymentId: string;
  mercadoPagoPaymentId: string | null;  // null if not payed
  externalReference: string;
  paidAt: AWSTimestamp | null;          // null if not payed
  price: number;
}

export interface UserAppointment {
  __typename: "Appointment";
  status: AppointmentStatus;
  description: string | null;
  since: AWSTimestamp;
  until: AWSTimestamp;
  createdAt: AWSTimestamp;
  cancellationMessage: string | null;
  statusCause: AppointmentStatusCause;      // Explain the cause (user, admin or payment) of why is in the current status
  business: UserAppointment_business;
  service: UserAppointment_service;
  resource: UserAppointment_resource;
  price: number | null;
  payment: UserAppointment_payment | null;  // If present, the appointment requires a payment to be confirmed
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserBusinesses
// ====================================================

export interface UserBusinesses_resources {
  __typename: "Resource";
  resourceId: string;  // WARNING: resourceId MUST always be generated with the same number of characters.
  name: string;
  pictureUrl: AWSURL | null;
  enabled: boolean;
}

export interface UserBusinesses {
  __typename: "Business";
  businessId: string;
  name: string;
  pictureUrl: AWSURL | null;
  timezone: string;
  businessHandle: string;
  email: AWSEmail | null;
  enabled: boolean;
  mercadoPagoLinked: boolean;  // This query can be used by any user (kept public to allow checking it before displaying the services) Returns true if the connection with a Mercado Pago account was set and can be used to require payments on services
  resources: UserBusinesses_resources[];
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: User
// ====================================================

export interface User {
  __typename: "User";
  userId: string;
  email: AWSEmail | null;        // User email is optional because businesses can create users with only the phone number
  name: string | null;
  phoneNumber: AWSPhone | null;  // User phoneNumber is optional because the user could "take" the phoneNumber of another user (removing it's phone number)
  pictureUrl: AWSURL | null;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: weeklyAvailability
// ====================================================

export interface weeklyAvailability_weeklyAvailability {
  __typename: "AvailabilitySpot";
  weekday: Weekday | null;
  durationMinutes: number;  // Max 24h * 60m = 1440m minutes (could span multiple days on DST)
  hour: number;             // 0 to 23 (both inclusive)
  minutes: number;          // 0 to 59 (both inclusive)
}

export interface weeklyAvailability {
  __typename: "Business";
  weeklyAvailability: weeklyAvailability_weeklyAvailability[];
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AppointmentStatus {
  CANCELED = "CANCELED",
  CONFIRMED = "CONFIRMED",
  PENDING = "PENDING",
}

export enum AppointmentStatusCause {
  ADMIN = "ADMIN",
  PAYMENT = "PAYMENT",
  USER = "USER",
}

export enum PaymentMethod {
  CASH = "CASH",
  CREDIT_AMEX = "CREDIT_AMEX",
  CREDIT_CABAL = "CREDIT_CABAL",
  CREDIT_DINERS = "CREDIT_DINERS",
  CREDIT_MASTER = "CREDIT_MASTER",
  CREDIT_VISA = "CREDIT_VISA",
  DEBIT_VISA = "DEBIT_VISA",
  MERCADOPAGO = "MERCADOPAGO",
}

export enum ResourceType {
  MACHINE = "MACHINE",
  PERSON = "PERSON",
  TYPE_OF_SERVICE = "TYPE_OF_SERVICE",
}

export enum Weekday {
  FRIDAY = "FRIDAY",
  MONDAY = "MONDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
  THURSDAY = "THURSDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
}

export enum ExportStatus {
  COMPLETED = "COMPLETED",
  CREATED = "CREATED",
  IN_PROGRESS = "IN_PROGRESS",
}

// undefined
export interface AppointmentInput {
  businessId: string;
  createdAt: AWSTimestamp;
  resourceId: string;
  since: AWSTimestamp;
  userId: string;
}

// undefined
export interface ExportInput {
  businessId: string;
  exportId: string;
  since: AWSTimestamp;
  until: AWSTimestamp;
}

// // - Exceptions should not overlap (there is no validation in the backend, it is only inefficient).
// - The backend uses resource's timezone to calculate the start time of the days.
// - Can't start before a sunday at 00:00 or end after next sunday at 00:00 ("until" timestamp is exclusive).
// - A single exception can't span between multiple weeks. This limitation is not being validated by the backend. If exceeded, the backend won't find it.
// - If a longer period is needed, create multiple exceptions.
export interface ExceptionInput {
  businessId: string;
  resourceId: string;
  since: AWSTimestamp;
  until: AWSTimestamp;
}

// undefined
export interface GenericAppointmentInput {
  businessId: string;
  createdAt: AWSTimestamp;
  description?: string | null;
  resourceId: string;
  serviceId: string;
  since: AWSTimestamp;
  user?: UserMakeAppointmentInput | null;
  userId?: string | null;
}

// undefined
export interface UserMakeAppointmentInput {
  email?: AWSEmail | null;
  phoneNumber: AWSPhone;
  userName?: string | null;
}

// undefined
export interface RequiredPaymentInput {
  price: number;
}

// undefined
export interface MakeAppointmentValidationsInput {
  anticipation: boolean;
  availability: boolean;
}

// undefined
export interface RequestHelpInput {
  description: string;
  summary: string;
}

// undefined
export interface RequestBusinessRegistrationInput {
  address: string;
  businessName: string;
  city: string;
  email: AWSEmail;
  fullName: string;
  phoneNumber: AWSPhone;
}

// undefined
export interface BusinessInput {
  _geoloc: GeoLocInput;
  address: AddressInput;
  backgroundPictureUrl?: AWSURL | null;
  businessHandle: string;
  businessId: string;
  cancellationPolicy?: string | null;
  category: string;
  description?: string | null;
  email?: AWSEmail | null;
  facebookProfileUrl?: AWSURL | null;
  instagramProfileUrl?: AWSURL | null;
  isDemo: boolean;
  name: string;
  paymentMethods: PaymentMethod[];
  phoneNumber: AWSPhone;
  pictureUrl?: AWSURL | null;
  subscriptionPaidUntil?: AWSTimestamp | null;
  tags: string[];
  timezone: string;
  twitterProfileUrl?: AWSURL | null;
  website?: AWSURL | null;
  weeklyAvailability: AvailabilitySpotInput[];
  whatsAppPhoneNumber?: AWSPhone | null;
}

// undefined
export interface GeoLocInput {
  lat: number;
  lng: number;
}

// undefined
export interface AddressInput {
  city: string;
  country: string;
  directions?: string | null;
  number: string;
  street: string;
  zipcode: string;
}

// undefined
export interface AvailabilitySpotInput {
  durationMinutes: number;
  hour: number;
  minutes: number;
  weekday?: Weekday | null;
}

// undefined
export interface ResourceInput {
  businessId: string;
  description?: string | null;
  labels: string[];
  name: string;
  overlappingRequirements: OverlappingRequirementsInput;
  pictureUrl?: AWSURL | null;
  resourceId: string;
  resourceType: ResourceType;
  weeklyAvailability: AvailabilitySpotInput[];
}

// undefined
export interface OverlappingRequirementsInput {
  sameInterval: boolean;
  sameService: boolean;
}

// undefined
export interface ServiceInput {
  appointmentsFrequencyMinutes: number;
  businessId: string;
  color?: string | null;
  concurrency: number;
  description?: string | null;
  durationMinutes: number;
  labels: string[];
  maxAnticipationDays: number;
  minAnticipationHours: number;
  name: string;
  pictureUrl?: AWSURL | null;
  price?: number | null;
  requiredPayment?: number | null;
  requiresConfirmation: boolean;
  resourcesId: string[];
  serviceId: string;
  weeklyAvailability: AvailabilitySpotInput[];
  weeklyAvailabilityByIntervals: AvailabilitySpotInput[];
}

// undefined
export interface NotificationsInput {
  email: boolean;
  push: boolean;
  sms: boolean;
  whatsApp: boolean;
}

// undefined
export interface UserAppointmentInput {
  businessId: string;
  createdAt: AWSTimestamp;
  resourceId: string;
  since: AWSTimestamp;
}

// undefined
export interface BusinessAppointmentInput {
  createdAt: AWSTimestamp;
  resourceId: string;
  since: AWSTimestamp;
  userId: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================